import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { map, Observable } from 'rxjs'
import { EnqueteDto } from '../models/enquete-dto'
import { ValidateDto } from '../models/validate-dto'

@Injectable({
    providedIn: 'root',
})
export class EnqueteService {
    private http = inject(HttpClient);


    getEnquete(enqueteId: string): Observable<EnqueteDto> {
        const path = `${environment.baseUrl}/enquetes`
        return this.http.get<EnqueteDto[]>(path, { params: { enqueteId: enqueteId } }).pipe(map((r) => r[0]))
    }

    validateEnquete(validateDto: ValidateDto): Observable<EnqueteDto> {
        const path = `${environment.baseUrl}/enquetes/validate`
        return this.http.post<EnqueteDto>(path, validateDto)
    }

    getEnquetes(): Observable<EnqueteDto[]> {
        const path = `${environment.baseUrl}/enquetes`
        return this.http.get<EnqueteDto[]>(path)
    }

    exportEnquetes(): Observable<string> {
        const path = `${environment.baseUrl}/enquetes/export`
        return this.http.get<string>(path)
    }

    updateEnquete(enquete: EnqueteDto, sendMail: boolean = false): Observable<EnqueteDto> {
        const path = `${environment.baseUrl}/enquetes?sendMail=${sendMail}`
        return this.http.post<EnqueteDto>(path, enquete)
    }
}
